export default "__VITE_ASSET__7ab050df__"